var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWoops = function SvgWoops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 96,
    viewBox: "0 0 355 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 96,
    rx: 6,
    fill: "#F2F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293 82H137V95H293V82Z",
    fill: "#C7D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268 13H89V28H268V13Z",
    fill: "#C7D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.169 6.38184H135.854V12.7636H145.169V6.38184Z",
    fill: "#D7E3EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.843 0H126.527V6.38175H135.843V0Z",
    fill: "#D7E3EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.533 6.38184H117.217V12.7636H126.533V6.38184Z",
    fill: "#D7E3EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6146 6.38184H61.2988V12.7636H70.6146V6.38184Z",
    fill: "#D7E3EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9369 0H70.6211V6.38175H79.9369V0Z",
    fill: "#D7E3EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2513 6.38184H79.9355V12.7636H89.2513V6.38184Z",
    fill: "#D7E3EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5736 0H89.2578V6.38175H98.5736V0Z",
    fill: "#D7E3EA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M107.89 6.38184H98.5742V12.7636H107.89V6.38184Z",
    fill: "#D7E3EA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M117.206 0H107.891V6.38175H117.206V0Z",
    fill: "#D7E3EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.486 0H145.17V6.38175H154.486V0Z",
    fill: "#D7E3EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.806 6.38184H154.49V12.7636H163.806V6.38184Z",
    fill: "#D7E3EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.122 0H163.807V6.38175H173.122V0Z",
    fill: "#D7E3EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.031 0H219.715V6.38175H229.031V0Z",
    fill: "#D7E3EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.714 6.38184H210.398V12.7636H219.714V6.38184Z",
    fill: "#D7E3EA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.398 0H201.082V6.38175H210.398V0Z",
    fill: "#D7E3EA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.076 6.38184H191.76V12.7636H201.076V6.38184Z",
    fill: "#D7E3EA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M191.761 0H182.445V6.38175H191.761V0Z",
    fill: "#D7E3EA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M182.439 6.38184H173.123V12.7636H182.439V6.38184Z",
    fill: "#D7E3EA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.843 0H126.527V6.38175H135.843V0Z",
    fill: "#D7E3EA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5736 0H89.2578V6.38175H98.5736V0Z",
    fill: "#D7E3EA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.206 0H107.891V6.38175H117.206V0Z",
    fill: "#D7E3EA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.486 0H145.17V6.38175H154.486V0Z",
    fill: "#D7E3EA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.122 0H163.807V6.38175H173.122V0Z",
    fill: "#D7E3EA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M229.031 0H219.715V6.38175H229.031V0Z",
    fill: "#D7E3EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M191.761 0H182.445V6.38175H191.761V0Z",
    fill: "#D7E3EA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1499 17.3091H39.6816V31.3423H48.1499V17.3091Z",
    fill: "#525252"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M258.346 17.3091H249.885V31.3423H258.346V17.3091Z",
    fill: "#525252"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M234.989 17.3091H226.527V31.3423H234.989V17.3091Z",
    fill: "#525252"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M211.646 17.3091H203.178V31.3423H211.646V17.3091Z",
    fill: "#525252"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M188.283 17.3091H179.814V31.3423H188.283V17.3091Z",
    fill: "#525252"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M164.922 17.3091H156.461V31.3423H164.922V17.3091Z",
    fill: "#525252"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.569 17.3091H133.107V31.3423H141.569V17.3091Z",
    fill: "#525252"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M118.211 17.3091H109.75V31.3423H118.211V17.3091Z",
    fill: "#525252"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8598 17.3091H86.3984V31.3423H94.8598V17.3091Z",
    fill: "#525252"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5004 17.3091H63.0391V31.3423H71.5004V17.3091Z",
    fill: "#525252"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M281.705 17.3091H273.244V31.3423H281.705V17.3091Z",
    fill: "#525252"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M305.055 17.3091H296.594V31.3423H305.055V17.3091Z",
    fill: "#525252"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.374 31.3374H128.145V53.5933H172.374V31.3374Z",
    fill: "#C0FC21"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M216.608 31.3374H172.379V53.5933H216.608V31.3374Z",
    fill: "#FABDBD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M260.837 31.3374H216.607V53.5933H260.837V31.3374Z",
    fill: "#F68D8D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M128.143 31.3374H83.9141V53.5933H128.143V31.3374Z",
    fill: "#B5BAE4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M341.62 34.5188V33.4615H316.608V32.3995H326.227V31.3374H260.838V53.598H333.924V52.5359H314.686V51.4786H322.383V50.4166H308.912V49.3592H312.764V48.2972H310.834V47.2399H306.989V46.1778H318.531V45.1205H322.383V44.0584H314.686V42.9964H308.912V41.939H305.067V40.877H330.072V39.8197H322.383V38.7576H308.912V37.7003H316.608V36.6382H310.834V35.5809H308.912V34.5188H341.62Z",
    fill: "#707BD7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7571 31.3374V32.3995H10.8278V33.4615H24.2984V34.5188H20.4467V35.5809H31.9949V36.6382H35.8397V37.7003H31.9949V38.7576H39.6846V39.8197H37.7622V40.877H33.9173V41.939H30.0656V42.9964H23.4716V44.0584H30.0656V45.1205H35.8397V46.1778H14.6795V47.2399H28.1432V48.2972H6.98295V49.3592H5.06055V50.4166H30.0656V51.4786H22.376V52.5359H28.1432V53.598H83.9137V31.3374H12.7571Z",
    fill: "#D9FF95"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66V60H82V66H91Z",
    fill: "#D7E3EA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M82 60V54H73V60H82Z",
    fill: "#D7E3EA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66V60H64V66H73Z",
    fill: "#D7E3EA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66V60H8V66H16Z",
    fill: "#D7E3EA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60V54H16V60H26Z",
    fill: "#D7E3EA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66V60H26V66H35Z",
    fill: "#D7E3EA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60V54H35V60H45Z",
    fill: "#D7E3EA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M54 66V60H45V66H54Z",
    fill: "#D7E3EA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60V54H54V60H64Z",
    fill: "#D7E3EA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M91 54V60H101V54H91Z",
    fill: "#D7E3EA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101 60V66H110V60H101Z",
    fill: "#D7E3EA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54V60H120V54H110Z",
    fill: "#D7E3EA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M166 54V60H175V54H166Z",
    fill: "#D7E3EA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M157 60V66H166V60H157Z",
    fill: "#D7E3EA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M147 54V60H157V54H147Z",
    fill: "#D7E3EA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138 60V66H147V60H138Z",
    fill: "#D7E3EA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M129 54V60H138V54H129Z",
    fill: "#D7E3EA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M120 60V66H129V60H120Z",
    fill: "#D7E3EA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82 60V54H73V60H82Z",
    fill: "#D7E3EA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60V54H35V60H45Z",
    fill: "#D7E3EA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60V54H54V60H64Z",
    fill: "#D7E3EA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M91 54V60H101V54H91Z",
    fill: "#D7E3EA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54V60H120V54H110Z",
    fill: "#D7E3EA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M166 54V60H175V54H166Z",
    fill: "#D7E3EA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M129 54V60H138V54H129Z",
    fill: "#D7E3EA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M259 66V60H249V66H259Z",
    fill: "#D7E3EA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M249 60V54H241V60H249Z",
    fill: "#D7E3EA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M241 66V60H231V66H241Z",
    fill: "#D7E3EA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M185 66V60H176V66H185Z",
    fill: "#D7E3EA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M193 60V54H185V60H193Z",
    fill: "#D7E3EA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M203 66V60H193V66H203Z",
    fill: "#D7E3EA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M212 60V54H203V60H212Z",
    fill: "#D7E3EA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M222 66V60H212V66H222Z",
    fill: "#D7E3EA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M231 60V54H222V60H231Z",
    fill: "#D7E3EA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M259 54V60H268V54H259Z",
    fill: "#D7E3EA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M268 60V66H278V60H268Z",
    fill: "#D7E3EA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M278 54V60H287V54H278Z",
    fill: "#D7E3EA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M334 54V60H343V54H334Z",
    fill: "#D7E3EA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M324 60V66H334V60H324Z",
    fill: "#D7E3EA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M315 54V60H324V54H315Z",
    fill: "#D7E3EA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M306 60V66H315V60H306Z",
    fill: "#D7E3EA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M297 54V60H306V54H297Z",
    fill: "#D7E3EA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M287 60V66H297V60H287Z",
    fill: "#D7E3EA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M249 60V54H241V60H249Z",
    fill: "#D7E3EA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M212 60V54H203V60H212Z",
    fill: "#D7E3EA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M231 60V54H222V60H231Z",
    fill: "#D7E3EA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M259 54V60H268V54H259Z",
    fill: "#D7E3EA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M278 54V60H287V54H278Z",
    fill: "#D7E3EA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M334 54V60H343V54H334Z",
    fill: "#D7E3EA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M297 54V60H306V54H297Z",
    fill: "#D7E3EA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M344 81H81V84H344V81Z",
    fill: "#525252"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M228 6H132V11H228V6Z",
    fill: "#525252"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M210 3H166V8H210V3Z",
    fill: "#FABDBD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5048 65V65.9975H48.3139V66.9994H27V67.9968H34.7524V68.9987H50.2503V70.0006H48.3139V70.7844H44.2191V71.7863H65.3248V72H67.053V71.7863H68.7811V72H70.5093V71.7863H72.2374V72H122V65H42.5048Z",
    fill: "#D9FF95"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M122 72H141V65H122V72Z",
    fill: "#FABDBD"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72H73V65H70V72Z",
    fill: "#FABDBD"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M67 72H69V65H67V72Z",
    fill: "#FABDBD"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M351.156 70.0006V68.9987H339.638V67.9968H343.482V66.9994H330.038V65.9975H331.956V65H141V72H351.156V70.9981H355V70.0006H351.156Z",
    fill: "#D9FF95"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M293 15H256V22H293V15Z",
    fill: "#D9FF95"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21H21V28H55V21Z",
    fill: "#B5BAE4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M87 5H46V10H87V5Z",
    fill: "#F68D8D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M199 12H99V13H199V12Z",
    fill: "#707BD7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.938 69.2173H144.395V81.32H145.938V69.2173ZM194.473 69.2173H192.93V81.32H194.473V69.2173ZM187.542 69.2173H189.085V81.32H187.542V69.2173ZM183.691 69.2173H182.147V81.32H183.691V69.2173ZM176.751 69.2173H178.294V81.32H176.751V69.2173ZM172.908 69.2173H171.365V81.32H172.908V69.2173ZM165.968 69.2173H167.512V81.32H165.968V69.2173ZM162.117 69.2173H160.574V81.32H162.117V69.2173ZM155.177 69.2173H156.72V81.32H155.177V69.2173ZM151.335 69.2173H149.791V81.32H151.335V69.2173ZM198.324 69.2173H199.868V81.32H198.324V69.2173ZM205.264 69.2173H203.721V81.32H205.264V69.2173ZM252.256 69.2173H253.799V81.32H252.256V69.2173ZM248.403 69.2173H246.859V81.32H248.403V69.2173ZM241.473 69.2173H243.017V81.32H241.473V69.2173ZM237.62 69.2173H236.077V81.32H237.62V69.2173ZM230.682 69.2173H232.226V81.32H230.682V69.2173ZM226.838 69.2173H225.294V81.32H226.838V69.2173ZM219.9 69.2173H221.443V81.32H219.9V69.2173ZM216.047 69.2173H214.503V81.32H216.047V69.2173ZM209.115 69.2173H210.659V81.32H209.115V69.2173ZM259.194 69.2173H257.65V81.32H259.194V69.2173ZM263.047 69.2173H264.59V81.32H263.047V69.2173ZM296.946 69.2173H295.403V81.32H296.946V69.2173ZM290.009 69.2173H291.552V81.32H290.009V69.2173ZM286.155 69.2173H284.612V81.32H286.155V69.2173ZM279.224 69.2173H280.767V81.32H279.224V69.2173ZM275.373 69.2173H273.829V81.32H275.373V69.2173ZM268.433 69.2173H269.976V81.32H268.433V69.2173Z",
    fill: "#525252"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M144 87H49V92H144V87Z",
    fill: "#525252"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M127 91H73V96H127V91Z",
    fill: "#F68D8D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M315 87H282V91H315V87Z",
    fill: "#B5BAE4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M37 74H0V81H37V74Z",
    fill: "#707BD7"
  })));
};
export default SvgWoops;